// extracted by mini-css-extract-plugin
export default {"root":"ButtonsWrap_root__tMg8t"};